import { FileDown } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconFileDown(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <FileDown />
    </IconWrapper>
  );
}
